<ng-select
  #ngSelect
  appendTo="body"
  [ngClass]="classList"
  (change)="onChange($event)"
  (open)="onOpen($event)"
  (clear)="onClear($event)"
  [placeholder]="placeholder"
  [items]="items"
  [multiple]="multiple"
  [closeOnSelect]="closeOnSelect"
  [searchable]="true"
  [loading]="loading"
  [(ngModel)]="value"
  [minTermLength]="0"
  [disabled]="isDisabled"
  [compareWith]="compareFn"
  [typeahead]="quickSearchTermInput$"
  loadingText="{{ 'CA::Loading' | abpLocalization }}..."
  bindLabel="name">
  > @if (autoSaveTag === true) {
  <ng-template ng-label-tmp let-item="item">
    <span>{{ item.name }}</span>
    <span
      *ngIf="item.id === 0"
      class="badge badge-secondary"
      style="
        position: absolute;
        right: 50px;
        top: 50%;
        transform: translateY(-50%);
        padding: 4px 8px;
        pointer-events: none;
        z-index: 10;
      ">
      {{ '::New' | abpLocalization }}
    </span>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-index="index">
    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
      <span>{{ item.name }}</span>
      <span *ngIf="item.id === 0" class="badge badge-secondary" style="padding: 4px 8px">
        {{ '::New' | abpLocalization }}
      </span>
    </div>
  </ng-template>
  }

  <ng-template ng-footer-tmp>
    <div class="w-100 d-flex d-flex flex-row justify-content-start align-items-center">
      <mat-paginator
        class="d-flex flex-row justify-content-row"
        style="flex: 0 0 350px"
        [length]="totalCount"
        [pageSize]="itemsPerPage"
        [pageIndex]="pageIndex"
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"></mat-paginator>
    </div>
  </ng-template>
</ng-select>
